var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChevron(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_2436_1837)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.336914,
    y: 0.337036,
    width: 46.5167,
    height: 46.5167,
    rx: 23.2583,
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.853766,
    y: 0.853888,
    width: 45.483,
    height: 45.483,
    rx: 22.7415,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1.0337
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8584 27.2745L21.5945 23.0106L25.8584 18.7468C25.9601 18.645 26.0408 18.5242 26.0959 18.3913C26.1509 18.2584 26.1793 18.1159 26.1793 17.972C26.1793 17.8281 26.1509 17.6856 26.0959 17.5527C26.0408 17.4198 25.9601 17.299 25.8584 17.1973C25.7566 17.0955 25.6358 17.0148 25.5029 16.9597C25.37 16.9047 25.2275 16.8763 25.0836 16.8763C24.9397 16.8763 24.7973 16.9047 24.6643 16.9597C24.5314 17.0148 24.4106 17.0955 24.3089 17.1973L19.2647 22.2414C19.1629 22.3431 19.082 22.4638 19.0269 22.5968C18.9717 22.7297 18.9434 22.8722 18.9434 23.0161C18.9434 23.1601 18.9717 23.3026 19.0269 23.4355C19.082 23.5685 19.1629 23.6892 19.2647 23.7909L24.3089 28.835C24.7375 29.2636 25.4298 29.2636 25.8584 28.835C26.276 28.4064 26.287 27.7031 25.8584 27.2745Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_2436_1837",
    x: -154.719,
    y: -154.719,
    width: 356.628,
    height: 356.628,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 77.5278
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2436_1837"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2436_1837",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevron);
export default __webpack_public_path__ + "static/media/chevron.e7615db121bb1ad7cc583eee6278566e.svg";
export { ForwardRef as ReactComponent };